<template lang="pug">
#sign-up-tab(style="min-height:30rem;")
  b-field
    b-switch(
      type="is-success"
      :value="event.registration_required"
      @input="set($event, 'registration_required')"
    )
      small Allow Sign Ups
  div(v-if="event.registration_required")
    b-field(label="Cut-off Date")
      b-datepicker(
        icon="calendar-today"
        :value="event.registration_deadline"
        @input="set($event, 'registration_deadline')"
      )
    //- b-field(label="Contact Name" expanded)
    //-   b-field(expanded)
    //-     user-select(
    //-       @input="setContact"
    //-     )
    //-     b-input(type="text" v-model="event._embedded.contact.name" expanded)
    //- b-field(grouped)
    //-   b-field(label="Contact Email" :message="`Listed publicly. Must be an @${account.host} email`" expanded)
    //-     b-input(type="email" v-model="event._embedded.contact.email")
    //-   b-field(label="Contact Phone Number" message="Listed publicly" expanded)
    //-     b-input(type="text" v-model="event._embedded.contact.phone_number")
    b-field(label="People to Notify")
      //- b-input(
      //-   type="text"
      //-   :value="event.notification_emails"
      //-   @input="set($event, 'registration_emails')"
      //- )
      b-taginput(
        type="is-primary"
        :confirm-key-codes="[13, 188, 9, 32]"
        :value="event.notification_emails"
        @input="set($event, 'notification_emails')"
      )

    b-field(style="margin-top:1.25rem;")
      b-switch(
        type="is-success"
        :value="event.payment_required"
        @input="set($event, 'payment_required')"
      )
        small Require Payment
    div(v-if="event.payment_required")
      b-notification(:closable="false" style="margin:1.25rem 0 0.75rem;") Define one or more price packages for this event. Remember that there is a credit card transaction fee of <b>2.9% + $0.30</b>.
      b-table(
        :data="event._embedded.packages"
        :striped="true"
      )
        template(slot-scope="props")
          b-table-column(label="Label")
            b-input(
              type="text"
              :disabled="event._embedded.packages.length === 1"
              :value="props.row.name"
              @input="setPackageField($event, props.index, 'name')"
            )
          b-table-column(label="Cost")
            vue-numeric.input(
              currency="$"
              name="cost"
              v-validate="'required'"
              :value="props.row.cost"
              :precision="2"
              @input="setPackageField($event, props.index, 'cost')"
            )
          b-table-column(label="Discount Cost")
            vue-numeric.input(
              currency="$"
              :value="props.row.discount_cost"
              :precision="2"
              @input="setPackageField($event, props.index, 'discount_cost')"
            )
          b-table-column(label="")
            b-field(grouped)
              p.control
                a.button.is-small(@click="addPackage(props.index)")
                  b-icon(icon="plus" size="is-small")
              p.control
                a.button.is-danger.is-small(
                  @click="deletePackage(props.index)"
                  :disabled="props.index === 0"
                )
                  b-icon(icon="close" size="is-small")
</template>

<script>
import { mapGetters } from 'vuex';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'sign-up-tab',
  computed: {
    ...mapGetters({
      event: getters.GET_EVENT,
    }),
  },
  created() {
    if (this.event._embedded.packages.length === 0) {
      this.$store.commit(mutations.ADD_PACKAGE_FOR_EVENT, {
        cost: 0,
        discount_cost: 0,
      });
    }
  },
  inject: ['$validator'],
  methods: {
    addPackage() {
      this.$store.commit(mutations.ADD_PACKAGE_FOR_EVENT, {
        cost: 0,
        discount_cost: 0,
      });
    },
    deletePackage(index) {
      if (index > 0) {
        const eventPackage = this.event._embedded.packages[index];
        if (eventPackage.id === undefined) {
          this.$store.commit(mutations.REMOVE_PACKAGE_FOR_EVENT, index);
        } else {
          const self = this;
          this.$buefy.dialog.confirm({
            title: 'Please confirm',
            message: 'Are you sure you want to delete this package?',
            type: 'is-danger',
            hasIcon: true,
            onConfirm() {
              self.$store.dispatch(actions.DO_DELETE_EVENT_PACKAGE, { id: eventPackage.id })
                .then(() => {
                  self.$store.commit(mutations.REMOVE_PACKAGE_FOR_EVENT, index);
                });
            },
          });
        }
      }
    },
    set(val, key) {
      this.$store.commit(mutations.SET_EVENT_FIELD, {
        key,
        val,
      });
    },
    setPackageField(val, index, key) {
      this.$store.commit(mutations.SET_PACKAGE_FIELD_FOR_EVENT, {
        key,
        index,
        val,
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/event/SignUpTab.vue